import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import 'bulma/css/bulma.css'
import 'font-awesome/css/font-awesome.css'

ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js